import * as React from "react";
const SvgShortcut = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M5.20503 5.13807C5.46538 4.87772 5.88749 4.87772 6.14784 5.13807L10.8619 9.85212C11.1222 10.1125 11.1222 10.5346 10.8619 10.7949C10.6015 11.0553 10.1794 11.0553 9.91907 10.7949L5.20503 6.08088C4.94468 5.82053 4.94468 5.39842 5.20503 5.13807Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M14 4C14 2.89543 13.1046 2 12 2H4C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V4ZM12 3.33333H4C3.63181 3.33333 3.33333 3.63181 3.33333 4V12C3.33333 12.3682 3.63181 12.6667 4 12.6667H12C12.3682 12.6667 12.6667 12.3682 12.6667 12V4C12.6667 3.63181 12.3682 3.33333 12 3.33333Z",
	fill: "currentColor"
}));
export default SvgShortcut;
